import * as React from 'react';

const BellSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="bell_svg__eds-icon--bell_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="bell_svg__eds-icon--bell_base"
            d="M2 19h1v1h1v-1h16v1h1v-1h1v-1H2z"
        />
        <path
            className="bell_svg__eds-icon--bell_curve"
            d="M13 10v1c2 0 3.6 1.5 3.6 3.4h1.1c0-2.4-2.1-4.4-4.7-4.4z"
        />
        <path
            className="bell_svg__eds-icon--bell_bell"
            d="M12.5 7V5H14V4h-4v1h1.5v2C6.2 7.3 2 11.6 2 17h20c0-5.4-4.2-9.7-9.5-10zm-.6 1c4.6 0 8.4 3.5 8.9 8H3c.5-4.5 4.3-8 8.9-8z"
        />
    </svg>
);

BellSvg.displayName = 'BellSvg';
export default BellSvg;
